import { colors } from "constants/colors";
import { PregnancyAnnounceOvulationGraphModel } from "models/pregnancyAnnounceOvulationGraphModel";
import { StyledText9 } from "styles/Text";
import * as RevealOvuGraphStyles from "./RevealOvuGraph.styles";

const RevealOvuGraph = ({
  graphData,
}: {
  graphData: PregnancyAnnounceOvulationGraphModel[];
}) => (
  <RevealOvuGraphStyles.StyledGraphContainer>
    {graphData.map((item, index) => {
      return (
        <RevealOvuGraphStyles.StyledOvuGroupBox
          $barCount={item.ovuListMensesCycle?.length ?? 0}
          key={`ovu-group-box-${index}`}
        >
          <RevealOvuGraphStyles.StyledOvuBarBox
            $isFirst={index === 0}
            $isLast={index === (graphData?.length ?? 0) - 1}
          >
            {item.ovuListMensesCycle?.map((ovu, index) => {
              return (
                <RevealOvuGraphStyles.StyledOvuBarItem
                  key={`ovu-bar-item-${index}`}
                  $height={ovu?.olv ? (ovu.olv * 100) / 10 : 0}
                  $isSelect={ovu?.preganatDtSameFg === 1}
                />
              );
            })}
          </RevealOvuGraphStyles.StyledOvuBarBox>
          <StyledText9 color={colors.white} $textAlign="center">
            {item.ovuTitle}
          </StyledText9>
        </RevealOvuGraphStyles.StyledOvuGroupBox>
      );
    })}
  </RevealOvuGraphStyles.StyledGraphContainer>
);
export default RevealOvuGraph;
